import { DatoCmsConsoleGiochiItemList, DatoCmsInstantRoulette, DatoCmsItemList } from 'lib/datoCms/types';
import { useMemo } from 'react';

type useGetItemModularContentProps = {
  itemModularContent?: Array<DatoCmsItemList | DatoCmsConsoleGiochiItemList>;
  consoleGiochiModelApiKey: string;
  cmsModelApiKey: string;
};

export const useGetItemListFromModularContent = ({
  itemModularContent,
  consoleGiochiModelApiKey,
  cmsModelApiKey,
}: useGetItemModularContentProps) => {
  const getValuesFromModulaContent = ({
    itemModularContent,
    consoleGiochiModelApiKey,
    cmsModelApiKey,
  }: useGetItemModularContentProps) => {
    let listName =
      itemModularContent && itemModularContent[0]._modelApiKey === consoleGiochiModelApiKey
        ? (itemModularContent[0] as DatoCmsConsoleGiochiItemList).typeOfGamesConsole
        : undefined;
    let cmsGameList =
      itemModularContent && itemModularContent[0]._modelApiKey === cmsModelApiKey
        ? (itemModularContent[0] as DatoCmsItemList).cmsGameList
        : undefined;
    let middlewareIdList =
      cmsGameList && cmsGameList.map((singleItem: DatoCmsInstantRoulette) => singleItem.middlewareId);
    return { listName, cmsGameList, middlewareIdList };
  };
  const { listName, cmsGameList, middlewareIdList } = useMemo(
    () =>
      getValuesFromModulaContent({
        itemModularContent,
        consoleGiochiModelApiKey,
        cmsModelApiKey,
      }),
    [itemModularContent, consoleGiochiModelApiKey, cmsModelApiKey]
  );
  return { listName, cmsGameList, middlewareIdList };
};
